export const CacheKeys = {
    ACTIVE_TUTORS: 'active-tutors',
    ADDRESS: 'address',
    AFFILIATE: 'affiliate',
    ANALYTICS: 'analytics',
    APPOINTMENT: 'appointment',
    APPOINTMENTS: 'appointments',
    AVAILABILITY: 'availability',
    BILLING: 'billing',
    COLLEGE: 'college',
    CONVERSATION: 'conversation',
    CONVERSATIONS: 'conversations',
    FLAGS: 'flags',
    FILE: 'file',
    MATCHES: 'matches',
    PENDING_MATCHES: 'pending_matches',
    MATCH: 'match',
    MATCH_QUEUE_POSITION: 'match-queue-position',
    MESSAGES: 'messages',
    NOTIFICATIONS_COUNTER: 'notifications-counter',
    NOTIFICATIONS: 'notifications',
    OTHER_USER: 'other-user',
    PAYMENT_METHODS: 'payment-methods',
    PERFORMANCE: 'performance',
    PLATFORMS: 'platforms',
    RANDOM_TUTORS: 'random-tutors',
    RECOMMENDATION: 'recommendation',
    RECOMMENDATIONS: 'recommendations',
    RECORDINGS: 'recordings',
    REFERRALS: 'referrals',
    SKILLS: 'skills',
    SUBSCRIPTION: 'subscription',
    TEMPLATES: 'templates',
    TEMPORARY_TOKEN: 'temp-token',
    TRANSACTIONS: 'transactions',
    TRANSFER_CANDIDATES: 'transfer-candidates',
    TUTOR_AVAILABILITY: 'tutor-availability',
    TUTOR: 'tutor',
    TUTOR_METRICS: 'tutor-metrics',
    USER_GROUP: 'user-group',
    HUDDLE: 'hudddle',
    HUDDLES: 'huddles'
};
export const Storage = {
    AB_ID: 'gp-ab-id',
    PREV_TRANSACTIONS_PERIOD: 'prev-transactions-period'
};
export const UserType = {
    PARENT: 'parent',
    STUDENT: 'student',
    TUTOR: 'tutor'
};
export const BotId = '5f7cf7e7b511760a6e147909';
export default {
    CacheKeys,
    Storage,
    UserType,
    BotId
};
//# sourceMappingURL=index.js.map